import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Icons } from '@vex/icons/icons';
import { MatDialog } from '@angular/material/dialog';
import { AttachmentService } from '@vex/http-service/attachment.service';
import { Toast, ToastrService } from 'ngx-toastr';
@Component({
  selector: 'complex-tree-table',
  templateUrl: './complex-tree-table.component.html',
  styleUrls: ['./complex-tree-table.component.scss']
})

export class ComplexTreeTableComponent extends Icons implements OnInit {
  
  attribute: any = {};
  isLoader: boolean = false;
  isCSPValue: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<ComplexTreeTableComponent>,
    private dialog: MatDialog,
    private attachmentService: AttachmentService,
    private toastrService: ToastrService,
  ) {
    super();  
  }

  getSelectionData(value, attribute) {
    let data = [];
    if(value[attribute.Name+'_data']) {
      let val = value[attribute.Name+'_data'];
      val = JSON.parse(val);
      let keys = Object.keys(val);
      keys.forEach(key => {
        let options = val[key];
        data = [...data, ...options]
      })
    }
    if(attribute.IsList) {
      return data.map(x=> {return x.Label});
    } else {
      return data[0].Label;
    }
  }
  
  ngOnInit() {
    // this.columns = Object.keys(this.defaults.data[0]);
    this.attribute = this.data.data.attribute;
    this.isCSPValue = this.data.data.isCSPValue;
    this.attribute['ComplexValue'] = JSON.parse(this.attribute.Value);

    // this.isLoader = true;
    let _Attribute = this.attribute.Attribute;
    this.fetchDataLoader();
    this.attribute['ComplexValue'][_Attribute.Name].forEach(data => {
      data['_ComplexAttributes'] = JSON.parse(JSON.stringify(_Attribute.AttributeType.AttributeTypes));
      data['_ComplexAttributes'].forEach(child_attr => {
        this.data.setFormControlVisibility(child_attr, this.data.data.attributes, true, data, this.data.data.collection);
        child_attr = JSON.parse(JSON.stringify(child_attr));
        this.recursiveComplexData(child_attr, data)
      });
    });
  }

  recursiveComplexData(parent_attr, parent_data){
    if (!parent_attr.IsComplex && !parent_attr.IsList && !parent_attr.IsFile) {
      if(parent_attr.DataUrl && parent_attr.DataUrl !== ''){
        parent_attr['Value'] = parent_data[parent_attr.Name];
        let lable_key = 'ddLable_'+parent_attr.Name;
        this.isLoader = true;
        this.data.manageDataUrl(parent_attr, parent_data, lable_key, false, true);
      }
    } else if(parent_attr.IsList) {
      this.isLoader = true;
      this.data.manageDataUrl(parent_attr, parent_data, '', true, true);
    } else if (parent_attr.IsComplex){
      let data = parent_data[parent_attr.Name];
      if(data) {
        data.forEach(child_data => {
          child_data['_ComplexAttributes'] = JSON.parse(JSON.stringify(parent_attr.AttributeTypes));
          child_data['_ComplexAttributes'].forEach((child_attr, index) => {
            this.data.setFormControlVisibility(child_attr, this.data.data.attributes, true, child_data, this.data.data.collection);
            child_attr = JSON.parse(JSON.stringify(child_attr));
            this.recursiveComplexData(child_attr, child_data);
          });
        });
      }
    }
  }

  fetchDataLoader(){
    let scope = this;
    setTimeout(() => {
      if(scope.data.totalHit !== scope.data.counter) {
        scope.fetchDataLoader()
      } else {
        scope.isLoader = false;
      }
    }, 500);
  }

  getFile(Id) {
    this.toastrService.info("Please wait for a while");
    this.attachmentService.getAttachmentGetById(Id).subscribe(
      (image) => {
        if(image != undefined && image != null) {
          let extensionArr = image.Path.split(".");
          let extension = extensionArr[extensionArr.length - 1];
          var a = document.createElement('a');
          a.href = image.Path;
          a.download = image.Name+'.'+extension;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      },
      (error) => {
        this.toastrService.warning("No attachment found");
      }
    )
  }

  getAttributes(attributes) {
    return attributes.filter(attribute => attribute.IsVisible == true && (this.isCSPValue || (!this.isCSPValue && ((attribute.DataGeneratedBy === 'CSP' && attribute.IsParentProperty == true) || attribute.DataGeneratedBy === 'User' || attribute.DataGeneratedBy === 'System'))));
  }
}
